<template src='./buttonPrimary.pug' lang='pug'></template>

<script>
import { trackAnalyticsEvent } from '../../../utils/analytics.js'

export default {
  name: 'ButtonPrimary',

  props: {
    faIcon: {
      type: String
    },
    label: {
      type: String
    },
    clickFunction: {
      type: Function,
      required: false
    },
    id: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'button'
    },
    customClass: {
      type: String
    },
    width: {
      type: String
    },
    title: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    trackEvent () {
      trackAnalyticsEvent(this, 'button-click', 'primary-button-component', this.id)
      if (typeof this.clickFunction !== 'undefined') {
        this.clickFunction()
      }
    }
  }
}
</script>

<style lang='css' scoped>
.common {
  font-family: 'Inter', sans-serif;
  min-width: 40px;
  text-align: center;
}

.common a {
  margin: 0 5px 0 5px;
}

.primary {
  background-color: #40b9bb;
  margin: 10px 0px 10px 0px;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  border-radius: 4px;
}

.secondary {
  margin: 10px 10px 10px 0;
  color: #666;
  background-color: #fff;
  border-color: #999;
}

.secondary:hover {
  color: #666;
  background-color: #EFEFEF;
  border-color: #999;
}

.secondary[disabled] {
  background-color: #EFEFEF;
  border: 1px solid #ccc;
  color: #666;
}

.secondary[disabled]:hover {
  background-color: #EFEFEF;
  border: 1px solid #ccc;
}

.big-primary {
  font-size: 17px !important;
}

.primary[disabled] {
  background-color: #c7c7c7;
  border: 1px solid #c7c7c7;
  color: #FFF;
}

.primary[disabled]:hover {
  background-color: #c7c7c7;
  border: 1px solid #c7c7c7;
}

.grayed {
  margin: 38px 10px 10px 0;
  color: #fff;
  background-color: #b0b0b0;
  border-color: #999;
}

.grayed:hover {
  color: #fff;
  background-color: #566573;
  border-color: #999;
}

.grayed[disabled] {
  background-color:  #5d6d7e;
  border: 1px solid #ccc;
  color: #fff;
}

.grayed[disabled]:hover {
  background-color: #85929e;
  border: 1px solid #ccc;
  color: #fff;
}

.danger {
  margin: 10px 10px 10px 0;
  color: #fff;
  background-color: rgb(234 106 106);
  border-color: #fff;
  border-radius: 4px;
}

.danger[disabled] {
  background-color: #f08f8f;
  border: 1px solid #ccc;
  color: #fff;
}
</style>




// WEBPACK FOOTER //
// ButtonPrimary.vue?1ee2957d